// Global Vars
// --------------------------------------------------

const $WINDOW = $(window);
const $DOC = $(document);
const $HTML = $('html');
const $BODY = $('body');
const $HTML_BODY = $('html, body');
//const $PAGE_WRAP = $('#page-wrap');
//const $PAGE_CONTENT = $('#page-content');

/*
const ga = ga || [];
const gtag = gtag || [];
const google = google || [];

const GTAG_ID = 'UA-849859-04';
*/

// Page State
// --------------------------------------------------

// prettier-ignore
/*
const PAGE = {
	isMenuOpen: false,
	isPageLoading: false,
	isTouchDevice: 'ontouchstart' in window || 'onmsgesturechange' in window,
	supports: {},
	activeModal: null
};

if (Modernizr.customevent) {
	PAGE.events = {
		loadStart: new Event('page:load-started'),
		contentHidden: new Event('page:content-hidden'),
		contentUpdated: new Event('page:content-updated'),
		loadCompleted: new Event('page:load-completed'),
		initLinks: new Event('page:init-links'),
		sidebarContentUpdated: new Event('page:sidebar-content-updated')
	};

	PAGE.supports.ajaxPageLoad = true;
}
*/
